/**
 * Environment variables.
 * @type {*} variable object.
 */
export const environment = {
  production: false,
  hCaptchaSiteKey: 'eed2a026-0f9e-407c-bf16-7ae25e8e6d34',
  showDebugInfo: true
};
